export class CarrierStatus {
  status: string;
  isManuallyMonitored: boolean;
  isTruckerToolsQualified: boolean;
  isAuthorizedToQuickBook: boolean;
  carrierTier: number;
}
